import { Injectable } from '@angular/core';
import { DeveloperOrganization } from '../../domain/models/developer-organization.model';
import { DeveloperOrganizationDto } from '../dtos/developer-context.dto';

@Injectable()
export class DeveloperOrganizationMapper {
  public toDeveloperOrganization(dto: DeveloperOrganizationDto): DeveloperOrganization {
    return { id: dto.Id, name: dto.Name };
  }
}
